<template>
  <div class="container border rounded-3 p-3">
    <label for="orderStatussen" class="form-label mb-1">Filter</label>
    <div v-for="status in sortedOrderstatussen" :key="status.id" class="form-check form-switch">
      <input class="form-check-input"
             @change="filterStatusChanged()"
             type="checkbox"
             v-model="filter.status[status.id]"
             :id="status.id" key="">
      <label class="form-check-label label-text" for="flexCheckDefault" :title="status.label">
        &nbsp;<i class="bi bi-circle-fill close" :class="getColor(status.id)"></i>&nbsp;{{ status.label }}
      </label>
    </div>
    <div>
      <div class="mt-3">
        <div class="align-items-start">
          <label for="startDate" class="form-label">Startdatum</label>
          <input type="datetime-local" id="startDate" class="form-control" v-model="filter.startDate"
                 @change="filterStatusChanged"/>

          <label for="startDate" class="form-label">Eindatum</label>
          <input type="datetime-local" id="endDate" class="form-control" v-model="filter.endDate"
                 @change="filterStatusChanged"/>
        </div>
      </div>
    </div>

    <div v-if="isAdmin">
      <hr>
      <div v-if="showAdvancedFilters">
        <div class="dropdown mt-4 ">
          <button class="btn btn-primary dropdown-toggle" type="button" @click="toggleDropdown()" aria-expanded="false">
            Selecteer klanten
          </button>
          <div v-if="dropdownOpen" class=" px-2">
            <form class="px-4 py-3">
              <div v-for="customer in customers" :key="customer.id" class="form-check mb-2">
                <input type="checkbox"
                       @change="filterStatusChanged()"
                       class="form-check-input"
                       v-model="filter.customer[customer.username.toLowerCase()]"
                       :id="'dropdown_' + customer.id">
                <label class="form-check-label ms-2" :for="'dropdown_' + customer.id">
                  {{ customer.name }}
                </label>
              </div>
            </form>
          </div>
        </div>
        <div>
          <p class="fs-6 text-start text-secondary"><i>{{ selectedCustomer }}</i></p>
        </div>
        <input type="text"
               class="rounded-input mt-1"
               v-model="filter.userAgentFilter"
               @input="filterStatusChanged()"
               placeholder="Filter op User Agent">
        <button type="button"
                class="btn btn-light btn-sm mt-2"
                @click="clearSelection">
          Wis selectie
        </button>
      </div>
      <div>
        <button type="button" class="btn btn-secondary btn-sm mt-2 position-relative" @click="toggleAdvancedFilters">
          {{ showAdvancedFilters ? 'Verberg Meer' : 'Toon Meer' }}
          <span v-if="activeAdvancedFilters"
                class="position-absolute top-0 start-100 translate-middle py-0 px-1 bg-danger border border-light rounded-circle">
            <span class="text-white fw-bolder px-1" style="font-size: 14px; line-height: 1;">!</span>
            <span class="visually-hidden">Geavanceerde filters zijn actief</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "../utils/Utils"
import {watch} from 'vue'
import ServiceFactory from '@/services/ServiceFactory'
import localDB from '../utils/localDB';

var capitalize = require('lodash/capitalize')
export default {
  name: 'FilterOrder',
  props: {
    orderstatussen: Array,
    isAdmin: Boolean
  },
  emits: ['filterStatusChanged'],
  data() {
    return {
      orderService: null,
      customerService: null,
      customers: [],
      filter: {
        status: {},
        customer: {},
        userAgentFilter: '',
        startDate: '',
        endDate: ''
      },
      selectedCustomer: "Geen selectie",
      userAgentFilter: '',
      dropdownOpen: false,
      sortedOrderstatussen: [],
      showAdvancedFilters: false,
      activeAdvancedFilters: false,
    }
  },
  watch: {
    orderstatussen(newOrderstatussen) {
      if (newOrderstatussen) {
        this.sortedOrderstatussen = [...newOrderstatussen].sort((a, b) => a.sort_position - b.sort_position);
      } else {
        this.sortedOrderstatussen = [];
      }
    }
  },
  methods: {
    getColor(status) {
      return Utils.getColorForOrderStatus(status)
    },
    filterStatusChanged() {
      this.activeAdvancedFilters = this.filter.userAgentFilter.length > 0 || Object.values(this.filter.customer).filter(active => active).length > 0;
      this.updateSelectedCustomerString();

      this.$emit('filterStatusChanged', this.filter)
    },
    updateSelectedCustomerString() {
      this.selectedCustomer = ""
      for (let customer in this.filter.customer) {
        let customerSelected = this.filter.customer[customer]
        if (customerSelected) {
          this.selectedCustomer += `${capitalize(customer)}, `
        }
      }
      if (this.selectedCustomer.length > 0) {
        this.selectedCustomer = this.selectedCustomer.slice(0, -2)
      } else {
        this.selectedCustomer = "Geen selectie"
      }
    },
    toggleAdvancedFilters() {
      this.showAdvancedFilters = !this.showAdvancedFilters;
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen
    },
    async loadCustomers() {
      try {
        let response = await this.customerService.getCustomers();
        this.customers = response.data;
        // Dynamisch vullen van filter.customer object
        this.customers.forEach(customer => {
          this.filter.customer[customer.username.toLowerCase()] = false;

        });
      } catch (error) {
        console.error('Fout bij laden klanten:', error);
      }
    },

    async clearSelection() {
      // Reset status filters
      Object.keys(this.filter.status).forEach(key => {
        this.filter.status[key] = false;
      });

      // Reset customer filters
      Object.keys(this.filter.customer).forEach(key => {
        this.filter.customer[key] = false;
      });

      // Reset userAgent filter
      this.filter.userAgentFilter = '';

      // Clear localStorage
      await localDB.removeItem('orderFilter');

      // Update UI
      this.activeAdvancedFilters = false;
      this.updateSelectedCustomerString();
      this.filterStatusChanged();
    }
  },
  async mounted() {
    //TODO fix addEventListener now I do not use addEventListener
    // this.orderService = ServiceFactory.getService('addEventListener')
    // this.orderService.addEventListener('ordersLoaded', () => {
    //   this.filterStatusChanged()
    // });

    this.customerService = ServiceFactory.getService('CustomerService');
    await this.loadCustomers();

    const storedFilter = await localDB.getItem('orderFilter');
    if (storedFilter) {
      const parsedFilter = JSON.parse(storedFilter);
      // Alleen opgeslagen customer filters toepassen die nog bestaan
      Object.keys(parsedFilter.customer).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(this.filter.customer, key)) {
          this.filter.customer[key] = parsedFilter.customer[key];
        }
      });
      this.filter.status = parsedFilter.status;
      this.filter.userAgentFilter = parsedFilter.userAgentFilter;
      // this.updateSelectedCustomerString();
    }

    this.filterStatusChanged();

    watch(() => this.filter, async (newValue) => {
      await localDB.setItem('orderFilter', JSON.stringify(newValue));
    }, {deep: true});
  }

}
</script>

<style scoped>
.form-check-input {
  position: relative;
  top: -2px;
}

.form-check {
  display: flex;
  align-items: center;
}

.label-text {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 180px;
  display: inline-block;
}

.rounded-input {
  border-radius: 8px;
  border: 1px solid #ced4da;
  padding: 0.375rem 0.75rem;
}
</style>